export default {"src":"/_next/static/media/cmt.75631d8f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};